enum PlanTimeType {
  MINUTE_120 = "MINUTE_120",
  MINUTE_90 = "MINUTE_90",
  MINUTE_60 = "MINUTE_60",
  MINUTE_30 = "MINUTE_30",
  MINUTE_15 = "MINUTE_15",
}

export default PlanTimeType;
